module.exports = __webpack_public_path__ + "img/oran_8kl.9f039fd0.jpg";